import { CompanyListPage } from '@/pages/crm/companies/CompanyListPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

const companiesSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(50),
	search: z.string().optional(),
	registryStatus: z.string().optional(),
	naceCode: z.string().optional(),
	// "Created" range, ISO instants so a filtered list is shareable.
	createdFrom: z.string().optional(),
	createdTo: z.string().optional(),
	duplicates: z.coerce.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/crm/companies/')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['clients.read'], redirectTo: '/dashboard' }),
	component: CompanyListPage,
	validateSearch: companiesSearchSchema,
});
